module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-593c88fb.png";